var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSarLg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21.5137,
    height: 24,
    viewBox: "0 0 21.5137 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 38020"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2182",
    d: "M12.6299 3.34407C13.5426 2.35003 14.1015 1.88421 15.1718 1.24999V15.4422L21.4997 14.14C21.4301 14.7699 21.3626 15.0375 21.2401 15.495C21.1176 15.9525 21.0017 16.3311 20.7747 16.8412L12.6299 18.5393V3.34407Z",
    fill: "#030F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2183",
    d: "M10.1243 0C8.80864 0.756545 8.58489 1.03824 7.58501 2.04117V17.6765L0.726471 19.1282C0.350555 19.7793 -0.0253596 21.7854 0.00149145 21.8206C0.0283425 21.8558 7.23977 20.2721 7.45714 20.2721C7.87869 20.0785 8.14632 19.9641 8.43273 19.621C8.71914 19.2778 9.09506 18.7059 9.09506 18.7059L9.82004 17.6149C10.0386 17.3071 10.1097 17.1213 10.1243 16.7614V0Z",
    fill: "#030F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2184",
    d: "M1.93132 13.3374L21.5136 9.19527C21.321 10.407 21.152 11.0064 20.7528 11.9418L1.20638 16.0839C1.34489 15.0494 1.45587 14.4612 1.93132 13.3374Z",
    fill: "#030F1B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 2185",
    d: "M13.3518 21.2172L21.5042 19.5351C21.3484 20.6677 21.1931 21.2713 20.7704 22.282L12.609 23.9999C12.7928 22.9234 12.958 22.3189 13.3518 21.2172Z",
    fill: "#030F1B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSarLg);
export default __webpack_public_path__ + "static/media/sar-lg.7c7fc9be77151decf85157e73012f37b.svg";
export { ForwardRef as ReactComponent };